import { ActionContext, Module } from 'vuex'
import { PipelineState, RootState } from '../store/state_models'

import opportunityService from '@/services/OpportunityServices'

export const pipelines: Module<PipelineState, RootState> = {
  namespaced: true,
  state: { pipelines: [], pipelinesPermissions: {}, locationId: undefined, isLoading: false },
  getters: {
    getById: (state: PipelineState) => {
      return (id: string) => state.pipelines.find(x => x.id === id)
    },

    isLoading: (state: PipelineState) => {
      return state.isLoading;
    },
  },
  mutations: {
    addUpdate: (state: PipelineState, payload: { pipelines: any[], locationId: string } ) => {
      state.pipelines = payload.pipelines
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    clearAll: (state: PipelineState) => {
      state.pipelines = []
      state.locationId = undefined
    },
    setPipelines: (state: PipelineState, payload: { pipelines: any[] } ) => {
      state.pipelines = payload.pipelines
    },
    replacePipeline: (state: PipelineState, payload: { pipeline: any } ) => {
      state.pipelines = state.pipelines.map(pipeline => pipeline.id === payload.pipeline.id ? payload.pipeline : pipeline)
    },
    addPipeline: (state: PipelineState, payload: { pipeline: any } ) => {
      state.pipelines.unshift(payload.pipeline)
    },
    deletePipeline: (state: PipelineState, payload: { pipelineId: string } ) => {
      state.pipelines = state.pipelines.filter(pipeline => pipeline.id !== payload.pipelineId)
    },
    setPipelinesPermissions: (state: PipelineState, payload: { permissions: any } ) => {
      payload.permissions?.forEach(permission => {
        state.pipelinesPermissions[permission.pipelineId] = permission
      })
    },
    addPipelinePermission: (state: PipelineState, payload: { pipelineId: string, permission: any } ) => {
      state.pipelinesPermissions[payload.pipelineId] = payload.permission
    }
  },
  actions: {
    async syncAll(
      context: ActionContext<PipelineState, RootState>,
      params: string | {locationId:string,forceRefresh?:boolean}
    ) {
      let locationId
      let forceRefresh = false
      if(typeof params === 'object')
      {
        locationId = params.locationId
        forceRefresh = Boolean(params.forceRefresh)
      } else {
        locationId = params
      }
      if (!locationId) {
        context.commit('clearAll')
        return
      }

      if (context.state.locationId === locationId && !forceRefresh) {
        return context.state.pipelines;
      }

      const permissionsLabEnabled = context.rootGetters['featureFlags/getForLocation']('pipelines.permissions')

      if (permissionsLabEnabled) {
        try {
          const permissionsResponse = await opportunityService.getPipelinesPermissions(locationId)
          context.commit('setPipelinesPermissions', { permissions: permissionsResponse.permissions })
        } catch (error) {
          // context.commit('setPipelinesPermissions', { permissions: {} })
          console.error('Error getting pipelines permissions', error)
        }
      }

      return new Promise((resolve, reject) => {
        opportunityService.getPipelines(locationId).then(({pipelines})=>{
          pipelines = pipelines.map(pipeline=>{
            pipeline.date_added = pipeline.dateAdded
            pipeline.date_updated = pipeline.dateUpdated
            delete pipeline.date_added
            delete pipeline.date_updated
            return pipeline
          })
          context.commit('clearAll')
          context.commit('addUpdate', {
            locationId: locationId,
            pipelines
        })

        resolve(context.state.pipelines.pipelines)
      }).catch((err)=>{
        resolve([])
      })
      })
    },
    logout: {
      root: true,
      handler: async (context: ActionContext<PipelineState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: async (context: ActionContext<PipelineState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
